import { createRouter, createWebHashHistory } from 'vue-router'
import admin from '@/components/admin'
import startGame from '@/components/startGame'
import welcomePage from '@/components/welcomePage'
import visitMuseum from '@/components/visitMuseum'
import childrenTour from '@/components/childrenTour'
import matchImages from '@/components/matchImages'

import dailyRituals from '@/components/dailyRituals'
import hiddenRealms from '@/components/hiddenRealms'

import itemsList from '@/components/itemsList'
import specificItemInfo from '@/components/specificItemInfo'
import godsMortals from '@/components/godsMortals'
import manFromEarth from '@/components/manFromEarth'
import serviceOfGods from '@/components/serviceOfGods'
import functionalAdministartion from '@/components/functionalAdministartion'
import internationalRelations from '@/components/internationalRelations'
import aLaGuerre from '@/components/aLaGuerre'
import egyptianNeighbors from '@/components/egyptianNeighbors'
import login from '@/components/login'

import RomanByzantine from '@/components/RomanByzantine'
import epicFury from '@/components/epicFury'
import YossiAbulafia from '@/components/YossiAbulafia'

export default createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/admin',
      name: 'admin',
      component: admin
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      props: true
    },
    {
      path: '/egyptianNeighbors',
      name: 'egyptianNeighbors',
      component: egyptianNeighbors,
      props: true
    },
    {
      path: '/hiddenRealms',
      name: 'hiddenRealms',
      component: hiddenRealms,
      props: true
    },
    {
      path: '/dailyRituals',
      name: 'dailyRituals',
      component: dailyRituals,
      props: true
    },
    {
      path: '/RomanByzantine',
      name: 'RomanByzantine',
      component: RomanByzantine,
      props: true
    },  
    {
      path: '/aLaGuerre',
      name: 'aLaGuerre',
      component: aLaGuerre,
      props: true
    },
    {
      path: '/internationalRelations',
      name: 'internationalRelations',
      component: internationalRelations,
      props: true
    },
    {
      path: '/functionalAdministartion',
      name: 'functionalAdministartion',
      component: functionalAdministartion,
      props: true
    },
    {
      path: '/serviceOfGods',
      name: 'serviceOfGods',
      component: serviceOfGods,
      props: true
    },
    {
      path: '/manFromEarth',
      name: 'manFromEarth',
      component: manFromEarth,
      props: true
    },
    {
      path: '/godsMortals',
      name: 'godsMortals',
      component: godsMortals,
      props: true
    },
    {
      path: '/specificItemInfo',
      name: 'specificItemInfo',
      component: specificItemInfo,
      props: true
    },
    {
      path: '/itemsList',
      name: 'itemsList',
      component: itemsList,
      props: true
    },
    {
      path: '/visitMuseum',
      name: 'visitMuseum',
      component: visitMuseum
    },
    {
      path: '/matchImages',
      name: 'matchImages',
      component: matchImages
    },
    {
      path: '/childrenTour',
      name: 'childrenTour',
      component: childrenTour
    },
    {
      path: '/startGame',
      name: 'startGame',
      component: startGame
    },
    {
      path: '/epicFury',
      name: 'epicFury',
      component: epicFury
    },
    {
      path: '/YossiAbulafia',
      name: 'YossiAbulafia',
      component: YossiAbulafia
    },
    {
      path: '/',
      name: 'welcomePage',
      component: welcomePage
    }
  ]
})
